var React = require('react');

function InfoEdit (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M21.457 6.13543L17.8645 2.54302L20.4208 0L24 3.57921L21.457 6.13543ZM0 24V20.4208L16.7781 3.64268L20.3573 7.22188L3.5792 24H0Z","fill":"#212121"}));
}

InfoEdit.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = InfoEdit;

InfoEdit.default = InfoEdit;
